export class UtilService {
  screenWidthInEm(): number {
    const fontSize = parseFloat(getComputedStyle(document.querySelector('body')!).fontSize) || 16;

    return window.innerWidth / fontSize;
  }

  isTouchDevice(): boolean {
    return 'ontouchstart' in window;
  }

  getCurrentLanguage(): string {
    return document.documentElement.lang;
  }

  getCurrentLanguageAsBCP47(): string {
    if (this.getCurrentLanguage() === 'nl') {
      return 'nl-NL';
    }

    if (this.getCurrentLanguage() === 'es') {
      return 'es-ES';
    }

    return 'en-US';
  }

  /**
   * Convert seconds to a human-readable time string. Eg 0:21, 24:20 or 1:23:54
   * @param seconds
   */
  convertSecondsToTimeString(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds / 60) % 60);
    const remainingSeconds = Math.floor(seconds % 60)
      .toString()
      .padStart(2, '0');

    if (hours === 0) {
      return `${minutes.toString()}:${remainingSeconds}`;
    }

    return `${hours.toString()}:${minutes.toString().padStart(2, '0')}:${remainingSeconds}`;
  }

  getSmallestAspectRatio(width: number, height: number): string {
    const gcd = (a: number, b: number): number => {
      return b === 0 ? a : gcd(b, a % b);
    };

    const divisor = gcd(width, height);
    const simplifiedWidth = width / divisor;
    const simplifiedHeight = height / divisor;

    return `${simplifiedWidth.toString()}:${simplifiedHeight.toString()}`;
  }
}
